/**
 * @classdesc Arabic Language Pack
 * @desc This class will be used to translate tokens into the Arabic language.
 * @namespace Languages.Arabic
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Arabic
 */
export const dictionary = {
    'years'   : 'سنوات',
    'months'  : 'شهور',
    'days'    : 'أيام',
    'hours'   : 'ساعات',
    'minutes' : 'دقائق',
    'seconds' : 'ثواني'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Arabic
 */
export const aliases = ['ar', 'ar-ar', 'arabic'];
